import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { OrdersService } from '@app/services/order/orders.service';
import { PdvService } from '@app/services/pdv/pdv.service';

@Component({
    selector: 'our-app',
    templateUrl: 'our-app.component.html',
    styleUrls: ['our-app.component.scss']
})
export class OurAppComponent {
    url: string = "";
    ios:"";
    android:"";
    constructor(
        private orderService : OrdersService,
        private pdvService: PdvService,
        @Inject(PLATFORM_ID) private platformId: Object
    ){
        this.url = this.getMobileOperatingSystem();
        this.pdvService.pdv.subscribe(
            (pdv) => {
                if (pdv) {
                    this.ios = pdv.ios;
                    this.android = pdv.android;
                }
            }
        )
    }
    getMobileOperatingSystem() {
        if (isPlatformBrowser(this.platformId)) {
            var ua = navigator.userAgent.toLowerCase();
            var windows8 = ua.indexOf("windows nt 6.2") > -1
            var mobile = ua.indexOf("mobile") > -1 || ua.indexOf("wp7") > -1;
            var iPhone = ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1;
            var android = ua.indexOf("android") > -1;
            var msie = ua.indexOf("msie") > -1;
            if (mobile && iPhone) return ('iPhone');
            else if (mobile && android) return ('android');
            else if (windows8) return ("windows8")
        }
      }
      close(){
        this.orderService.ourAppEvent.next(false);
      }

}
